import cx from 'classnames'
import { WorkspaceUserWithAttributes } from 'enablex/sdk'
import { lang } from 'enablex/shared'
import _ from 'lodash'
import moment from 'moment'
import React, { FC } from 'react'

import UserIcon from '~/icons/UserIcon'
import style from '../style.scss'
import UserActions from './UserActions'

interface Props {
  user: WorkspaceUserWithAttributes
  showPicture: boolean
  currentUserEmail: string
  currentUserisAdminUser: boolean
  currentUserisSuperAdmin: boolean
  currentUserisEnablexAdmin: boolean
  onUserUpdated: () => void
  onPasswordReset: (email, password) => void
}

const User: FC<Props> = ({ user, showPicture, currentUserEmail,currentUserisAdminUser,currentUserisSuperAdmin,currentUserisEnablexAdmin, onUserUpdated, onPasswordReset }) => {
  let online = false
  if (user.role === 'agent') {
    online = user.attributes.isOnline
  }
  const timeFormat = 'DD/MM/YY hh:mm A'
  return (
    <div className={cx(style.tableRow, style.list, 'bp_table-row')} key={`user-${user.email}`}>
      <div style={{ display: 'flex', flexDirection: 'column', padding: '1rem  0.6rem' }}>
        <div className={cx(style.details, style.pullLeft)}>
          <div style={{ display: 'flex', gap: '15px' }}>
            <div className={style.picture}>
              {showPicture ? (
                <img src={user.attributes.picture_url} />
              ) : (
                <div className={style.userNoImage}>
                  <UserIcon height="40" width="40" color="#ffffff" />
                </div>
              )}
              {/* {user.role === 'agent' && (
                <div className={cx(style.userOnlineStatus, online ? style.online : style.offline)}></div>
              )} */}
            </div>

            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <div className={style.nameZone}>
                {_.get(user, 'attributes.firstname', '')}
                &nbsp;
                {_.get(user, 'attributes.lastname', '')}
              </div>
              <div className={style.userRole}>
                {user.role === 'admin' && !!user.isEnablexAdmin && (
                  <div>
                    <strong>{user.customerAdmin?.length > 0 ? 'Manager' : 'Owner'}</strong>
                  </div>
                )}
              </div>
              <div className={style.userEmail}>
                <span className={style.emailField}>
                  {/* <b>{lang.tr('email')}: </b> */}
                  {user.email}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className={style.dates}>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <span className={style.field}>
              <span style={{fontFamily: 'Barlow SemiBold'}}>{lang.tr('admin.workspace.users.collaborators.created')}:&nbsp;</span>
              {moment(user.attributes.created_at).format(timeFormat)}
            </span>
            <span className={style.field}>
              <span style={{fontFamily: 'Barlow SemiBold'}}>{lang.tr('admin.workspace.users.collaborators.lastLogin')}:&nbsp;</span>
             {user.attributes.last_logon ? moment(user.attributes.last_logon).format(timeFormat) : 'never'}
            </span>
            {user.role === 'agent' && user.supervisor_id && (
              <span className={style.field}>
                <span style={{fontFamily: 'Barlow SemiBold'}}>Supervisor:&nbsp;</span>
                {user.supervisor_id}
              </span>
            )}
            {(user.role === 'agent' || user.role === 'supervisor') && (
              <span className={style.field}>
                <span style={{fontFamily: 'Barlow SemiBold'}}>Status:&nbsp;</span>
                <span style={{
                  color: online ? '#0f5132' : '#842029',
                  backgroundColor: online ? '#d1e7dd' : '#f8d7da',
                  padding: '2px 8px',
                  borderRadius: '4px',
                  fontSize: '12px',
                  textTransform: 'capitalize',
                  fontWeight: 500
                }}>
                  {online ? 'Online' : 'Offline'}
                </span>
              </span>
            )}
          </div>
          <div>
            {(user.email.toLowerCase() !== currentUserEmail) && (currentUserisSuperAdmin ||  (currentUserisAdminUser && !currentUserisEnablexAdmin && user.role !== 'admin') || (currentUserisAdminUser && currentUserisEnablexAdmin) ) && (
              <UserActions user={user} onUserUpdated={onUserUpdated} onPasswordReset={onPasswordReset} />
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default User
